import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import PropTypes from 'prop-types';
import React from 'react';
import ShopPoster from '../ShopPoster';
import Blends from './Blends';
import css from './ProductSpotlight.module.scss';
import FeaturesScroller from './FeaturesScroller';
import ProductItems from './ProductItems';
import VideoPreviewer from './VideoPreviewer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ProductSpotlight = function ProductSpotlight(_ref) {
  var blends = _ref.blends,
      blendsTitle = _ref.blendsTitle,
      cornerImage = _ref.cornerImage,
      fabric = _ref.fabric,
      features = _ref.features,
      fullVideoCaptions = _ref.fullVideoCaptions,
      fullVideoSrc = _ref.fullVideoSrc,
      fullVideoDescription = _ref.fullVideoDescription,
      posterCta = _ref.posterCta,
      posterImage = _ref.posterImage,
      posterMessage = _ref.posterMessage,
      posterUrl = _ref.posterUrl,
      previewPoster = _ref.previewPoster,
      previewSrc = _ref.previewSrc,
      previewTrack = _ref.previewTrack,
      productItems = _ref.productItems,
      productItemsTitle = _ref.productItemsTitle;
  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsx(VideoPreviewer, {
      fullVideoCaptions: fullVideoCaptions,
      fullVideoSrc: fullVideoSrc,
      fullVideoDescription: fullVideoDescription,
      previewPoster: previewPoster,
      previewSrc: previewSrc,
      previewTrack: previewTrack,
      title: fabric
    }), /*#__PURE__*/_jsx(FeaturesScroller, {
      features: features
    }), /*#__PURE__*/_jsx(Blends, {
      blends: blends,
      cornerImage: cornerImage,
      title: blendsTitle
    }), /*#__PURE__*/_jsx(ProductItems, {
      fabric: fabric,
      items: productItems,
      title: productItemsTitle
    }), /*#__PURE__*/_jsx(ShopPoster, {
      cta: posterCta,
      image: posterImage,
      message: posterMessage,
      url: posterUrl
    })]
  });
};

ProductSpotlight.defaultProps = {
  fabric: '',
  fullVideoCaptions: false,
  fullVideoDescription: false,
  previewTrack: false
};
ProductSpotlight.propTypes = {
  blends: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  blendsTitle: PropTypes.string.isRequired,
  cornerImage: PropTypes.string.isRequired,
  fabric: PropTypes.string,
  features: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  fullVideoCaptions: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  fullVideoSrc: PropTypes.string.isRequired,
  fullVideoDescription: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  posterCta: PropTypes.string.isRequired,
  posterImage: PropTypes.string.isRequired,
  posterMessage: PropTypes.string.isRequired,
  posterUrl: PropTypes.string.isRequired,
  productItems: PropTypes.arrayOf(PropTypes.shape(_objectSpread({}, ProductItems.propTypes))).isRequired,
  productItemsTitle: PropTypes.string.isRequired,
  previewPoster: PropTypes.string.isRequired,
  previewSrc: PropTypes.string.isRequired,
  previewTrack: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};
export default ProductSpotlight;